import { render } from "./Article-ad-images.vue?vue&type=template&id=bbf24be0"
import script from "./Article-ad-images.vue?vue&type=script&lang=js"
export * from "./Article-ad-images.vue?vue&type=script&lang=js"

import "./Article-ad-images.vue?vue&type=style&index=0&id=bbf24be0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__